import administrator from './service';
export default {
    administrator
};